import ProductList2 from "./ProductList2";
import ListShareMenu from "../components/ListShareMenu";
import InvitePeople from "./InvitePeople";
import { getBaseURL } from "../lib/getBaseURL";
import { Link, useParams } from "react-router-dom";
import { UserAuth } from "../Context";
import InvitedMembersList from "./InvitedMembersList";
import ShopListMoreUserProfile from "./ShopListMoreUserProfile";
import CloneModal from "./CloneModal";
import { useEffect, useState } from "react";
import { collection, doc, getDoc } from "firebase/firestore";
import { db } from "../FirebaseConfig";
const SingleChat2 = ({
  list,
  setActiveAccordion,
  isSmallScreen,
  shoppingListData,
  setShoppingListData,
  setLoading,
  type,
  ownerId = null,
}) => {
  const baseURL = getBaseURL();
  const { user } = UserAuth();
  const { uid } = useParams();
  const isCurrentUserProfile = user?.uid === uid;
  const [invitedMe, setInvitedMe] = useState(false);
  const [isOpenManageMembersTray, setIsOpenManageMembersTray] = useState(false);
  const [isOpenInvitePeopleTray, setIsOpenInvitePeopleTray] = useState(false);

  const BackgroundOnSvg = ({ children }) => (
    <div
      style={{
        width: "30px",
        height: "30px",
        borderRadius: "8px",
        backgroundColor: "#F1F4FF",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children}
    </div>
  );
  const closeOtherDropdown = () => {
    let dropdowns = document.getElementsByClassName(`Other`);
    dropdowns.forEach((dropdown) => {
      if (dropdown.classList.contains(list?.listId)) {
        if (dropdown.classList.contains("show")) {
          dropdown.classList.remove("show");
          dropdown.children[0].classList.remove("show");
          dropdown.children[0].ariaExpanded = "false";
          dropdown.children[1].classList.remove("show");
        }
      }
    });
  };
  useEffect(() => {
    if (isCurrentUserProfile) return;
    const memberCheck = async () => {
      try {
        const userRef = doc(db, "users", ownerId);
        const shoppingListRef = doc(userRef, "shoppingList", list?.listName);
        const membersRef = collection(shoppingListRef, "members");
        const memberDocRef = doc(membersRef, user?.uid);

        const docSnapshot = await getDoc(memberDocRef);

        if (docSnapshot.exists()) {
          console.log("User is a member of this list", list?.listName);
          setInvitedMe(true);
        } else {
          console.log("User is not a member of this list", list?.listName);
          setInvitedMe(false);
        }
      } catch (error) {
        console.error("Error checking membership:", error);
        return false;
      }
    };
    memberCheck();
  }, [list]);
  return (
    <div
      className="d-flex flex-column shoppingList"
      style={{ padding: "6px 0px" }}
      key={list?.listId}
    >
      {/* Shopping List Header */}
      <div
        className={`d-flex justify-content-between align-items-center bg-mode`}
        style={{ padding: isSmallScreen ? "6px 0px" : "10px 0px" }}
      >
        <div className="d-flex align-items-center">
          <div
            style={{
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation();
              setActiveAccordion([]);
            }}
          >
            <svg
              width="36"
              height="50"
              viewBox="0 0 36 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 33L6 25L14 17"
                stroke="#667085"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <div className="d-flex flex-column" style={{ gap: "4px" }}>
            <div
              title={list?.name}
              style={{
                fontFamily: "Inter",
                fontWeight: 600,
                fontSize: isSmallScreen ? "16px" : "20px",
                lineHeight: "112%",
                letterSpacing: "0%",
                color: "black",
              }}
            >
              {list?.name}
            </div>
            {isCurrentUserProfile && (
              <InvitedMembersList
                listName={list?.id}
                userId={type === "myList" ? user?.uid : list?.userId}
                listId={list?.listId}
                isSmallScreen={isSmallScreen}
                isOpen={isOpenManageMembersTray}
                setIsOpen={setIsOpenManageMembersTray}
                componentName={"SingleChat"}
              />
            )}
          </div>
        </div>

        <div
          className="d-flex align-items-center"
          style={{ gap: isSmallScreen ? "10px" : "14px" }}
        >
          {(isCurrentUserProfile || invitedMe) && (
            <div
              onClick={(e) => e.stopPropagation()}
              title="Invite Collaborators"
            >
              <InvitePeople
                selectedShopList={list}
                ownerId={ownerId}
                listId={list?.listId}
                listName={list?.name}
                myName={user?.displayName}
                listLink={`${baseURL}/#/shoppingList/${list?.listId}/${
                  type === "myList" ? user?.uid : list?.userId
                }`}
                componentName={"ShoppingList"}
                closeOtherDropdown={closeOtherDropdown}
                isOpen={isOpenInvitePeopleTray}
                setIsOpen={setIsOpenInvitePeopleTray}
              />
            </div>
          )}
          {(isCurrentUserProfile || invitedMe) && (
            <div onClick={(e) => e.stopPropagation()} title="Chat">
              <Link to={`/chat/${list?.listId}`}>
                <svg
                  style={{
                    width: isSmallScreen ? "22px" : "26px",
                    height: isSmallScreen ? "22px" : "26px",
                  }}
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17 2.99502C15.5291 2.14417 13.8214 1.6572 12 1.6572C6.47715 1.6572 2 6.13435 2 11.6572C2 13.2569 2.37562 14.7688 3.04346 16.1097C3.22094 16.466 3.28001 16.8733 3.17712 17.2578L2.58151 19.4839C2.32295 20.4502 3.20701 21.3342 4.17335 21.0757L6.39939 20.4801C6.78393 20.3772 7.19121 20.4363 7.54753 20.6137C8.88837 21.2816 10.4003 21.6572 12 21.6572C17.5228 21.6572 22 17.18 22 11.6572C22 9.8358 21.513 8.12807 20.6622 6.6572"
                    stroke="#14191F"
                    stroke-linecap="round"
                  />
                  <path
                    d="M8 11.6571H8.009M11.991 11.6571H12M15.991 11.6571H16"
                    stroke="#14191F"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </Link>
            </div>
          )}
          <div
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
            }}
            title="Clone Shopping List"
          >
            <CloneModal
              list={list}
              listName={list?.name}
              userId={user?.uid}
              shoppingListData={shoppingListData}
              setShoppingListData={setShoppingListData}
              setLoading={setLoading}
              BackgroundOnSvg={BackgroundOnSvg}
              closeOtherDropdown={closeOtherDropdown}
              disable={list?.products?.length === 0}
            />
          </div>
          <div
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
            }}
            title="Share Shopping List"
          >
            <ListShareMenu
              list={list}
              listName={list?.name}
              myName={user?.displayName}
              listLink={`${baseURL}/#/shoppingList/${list?.listId}/${list?.userId}`}
              listId={list?.listId}
              userId={user?.uid}
              products={list?.products}
              BackgroundOnSvg={BackgroundOnSvg}
              componentName={"shopListMore"}
              // closeOtherDropdown={closeOtherDropdown}
            />
          </div>
          {isCurrentUserProfile && type === "myList" && (
            <ShopListMoreUserProfile
              list={list}
              shoppingListData={shoppingListData}
              setShoppingListData={setShoppingListData}
              setLoading={setLoading}
              BackgroundOnSvg={BackgroundOnSvg}
              setActiveAccordion={setActiveAccordion}
              imageWidth={isSmallScreen ? "22px" : "24px"}
              svgWidth={isSmallScreen ? "22px" : "24px"}
              showShareButton={true}
              showInviteButton={false}
              type={type}
            />
          )}
        </div>
      </div>
      {/* Shopping List Body */}
      <div onClick={(e) => e.stopPropagation()}>
        {/* {shoppingListData?.length > 0 && <hr className="m-0 p-0" />} */}
        <ProductList2
          shoppingListData={shoppingListData}
          selectedShopListName={list?.name}
          selectedShopListId={list?.listId}
          userId={user?.uid}
          componentName={"ShoppingList"}
          ownerId={type === "myList" ? user?.uid : list?.userId}
          type={type}
        />
      </div>
    </div>
  );
};

export default SingleChat2;
